var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.832,
    height: 17.851,
    viewBox: "0 0 17.832 17.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    transform: "translate(-68.494 -68.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3218",
    "data-name": "Group 3218",
    transform: "translate(68.494 68.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M68.494,86.172l1.249-4.436a8.9,8.9,0,1,1,3.325,3.258Zm4.808-2.8.273.166a7.392,7.392,0,1,0-2.38-2.326l.184.286-.719,2.554Z",
    transform: "translate(-68.494 -68.321)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M149.6,152.858l-.578-.031a.7.7,0,0,0-.5.17,2.632,2.632,0,0,0-.866,1.326,4.02,4.02,0,0,0,.932,3.152,9.376,9.376,0,0,0,5.054,3.674,2.463,2.463,0,0,0,2.086-.258,1.865,1.865,0,0,0,.812-1.184l.092-.431a.3.3,0,0,0-.167-.335l-1.953-.9a.3.3,0,0,0-.362.089l-.767.994a.219.219,0,0,1-.247.073,6,6,0,0,1-3.249-2.78.222.222,0,0,1,.028-.247l.733-.848a.3.3,0,0,0,.049-.313l-.842-1.969A.3.3,0,0,0,149.6,152.858Z",
    transform: "translate(-143.172 -148.098)",
    fill: "#989898"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.90bb0cca4bfd99e4c0335d3a97a1a531.svg";
export { ForwardRef as ReactComponent };